import React, { Fragment, useEffect, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { Breadcrumbs, H3 } from "../../../../AbstractElements";
import { Card, CardHeader, Form, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { AddItem, ProOption, SEO, AdditionImage, EditItem } from "../../../../Constant";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { addStoreItem, editItem, getcategoryitems, getcategoryitemsRole, statusTax, statusTaxRole, viewItem, viewItemRole } from "../../../../CommonUrl";
import Transparentspinner from "../../../Common/Loader/Transparentspinner";
import HandleApiError from "../../../Common/ErrorImport/ErrorImport";
import DefaultForm from "./Default";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../../Utils/restUtils";
import ItemForm from "./Item";
import ProOptionForm from "./ProOption";
import SEOForm from "./SEO";
import { toast } from 'react-toastify';

const productSchema = yup.object().shape({
    point: yup
        .string()
        .required('Point is required')
        .min(0, 'Point cannot be negative'),

    minOrder: yup
        .string()
        .required('Minimum order is required')
        .test("min-required-if-max", "Minimum order is required", function (value) {
            const { maxOrder } = this.parent;
            return !(maxOrder && (value === null || value === undefined || value === ""));
        })
        .test(
            "min-less-than-max",
            "Minimum must be less than maximum",
            function (value) {
                const { maxOrder } = this.parent;
                if (value && maxOrder) {
                    return Number(value) < Number(maxOrder);
                }
                return true;
            }
        ),

    maxOrder: yup
        .string()
        .required('Maximum order is required')
        .test("max-required-if-min", "Maximum order is required", function (value) {
            const { minOrder } = this.parent;
            return !(minOrder && (value === null || value === undefined || value === ""));
        })
        .test(
            "max-greater-than-min",
            "Maximum must be greater than minimum",
            function (value) {
                const { minOrder } = this.parent;
                if (value && minOrder) {
                    return Number(value) > Number(minOrder);
                }
                return true;
            }
        ),

    category: yup
        .mixed()
        .required('Category is required'),

    quantity: yup
        .string()
        .required('Quantity is required')
        .min(0, 'Quantity cannot be negative'),

    purchase_price: yup
        .string()
        .required('Purchase price is required')
        .min(0, 'Purchase price cannot be negative'),

    sales_price: yup
        .string()
        .required('Sales price is required')
        .min(0, 'Sales price cannot be negative'),

    sku: yup
        .string()
        .required('SKU is required')
    ,

    itemName: yup
        .string()
        .required('Item name is required')

})

const ItemEditTab = () => {
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");
    const [loading, setLoading] = useState(false);
    const [IconWithTab, setIconWithTab] = useState('1');
    const [uploadedImages, setUploadedImages] = useState([]);
    const [additionalImages, setAdditionalImages] = useState([]);
    const [categoryOption, setCategoryOption] = useState([]);
    const [taxOption, setTaxOption] = useState([]);
    const [apiImage, setapiImage] = useState(null);
    const [attributeItem, setAttributeItem] = useState([]);
    const [itemApiData, setItemApiData] = useState(null);

    useEffect(() => {
        const inputElement = document.querySelectorAll('input[type="number"]');
        const preventScrollEvent = (event) => {
            event.preventDefault();
        };
        inputElement.forEach((inputElement) => {
            inputElement.addEventListener('wheel', preventScrollEvent);
        });
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewItem + `?item_id=${param1}` : viewItemRole + `?item_id=${param1}`);
            if (data.status === true) {
                const single_Api = data.data[0];
                setAttributeItem(single_Api?.item_attribute);
                setapiImage(single_Api.item_image || null);
                setAdditionalImages(single_Api?.additional_images)
                setItemApiData(single_Api); // Store in state for next effect
            } else if (data.status >= 400 && data.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (data.status >= 500 && data.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
            setLoading(false);
        };
        fetchData();
    }, []);


    const methods = useForm({
        resolver: yupResolver(productSchema),
        defaultValues: {
            rows: [],
        }
    });

    const { register, handleSubmit, setValue,trigger, control, formState: { errors }, getValues } = methods;

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'rows'
    });

    useEffect(() => {
        const fetchOptions = async () => {
            const categoryRes = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getcategoryitems : getcategoryitemsRole);
            const taxRes = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? statusTax : statusTaxRole);

            if (categoryRes.status && taxRes.status) {
                const categoryList = categoryRes.data.map((data) => ({ value: data.id, label: data.name }));
                const taxList = taxRes.data.map((data) => ({ value: data.id, label: data.title }));

                setCategoryOption(categoryList);
                setTaxOption(taxList);
            } else if (categoryRes.status >= 400 && categoryRes.status <= 405) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
            } else if (categoryRes.status >= 500 && categoryRes.status <= 505) {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
            } else {
                navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
            }
        };
        fetchOptions();
    }, []);

    useEffect(() => {
        if (!itemApiData || taxOption.length === 0 || categoryOption.length === 0) return;
        const formattedNumberString = itemApiData?.sale_price
        const formattedPurchase = itemApiData?.purchase_price

        setValue('itemName', itemApiData.name);
        setValue('quantity', itemApiData.stock);
        setValue('sku', itemApiData.sku);
        setValue('sales_price', formattedNumberString);
        setValue('purchase_price', formattedPurchase);
        setValue('weight', itemApiData.weight);
        setValue('minOrder', itemApiData.min_order);
        setValue('maxOrder', itemApiData.max_order);
        setValue('point', itemApiData.points);
        setAttributeItem(itemApiData.item_attribute);
        setapiImage(itemApiData.item_image || null);
        setValue('isFeatured', itemApiData?.featured);
        setValue('isWeb', itemApiData?.website_show);
        setValue('isShip', itemApiData?.delivery_charge);
        setValue('metaTitle', itemApiData?.seo_title);
        setValue('metaDescription', itemApiData?.seo_description);
        const selectedTax = taxOption.find(t => t.value === itemApiData.tax_group_id);
        const selectedCategory = categoryOption.find(c => c.value === itemApiData.category_id);
        setValue('tax', selectedTax ?? null);
        setValue('category', selectedCategory ?? null);
        setValue('description',itemApiData?.description)

    }, [taxOption, categoryOption]);

    const onSubmit = async (data) => {
        const formData = new FormData();
        const filteredRows = data.rows.filter((item) => item.attribute?.value);
        const apiData = filteredRows.map((item, index) => {
            if (item.images instanceof File) {
                formData.append(`attribute_images[${index}]`, item.images);
            } else {
                formData.append(`attribute_images[${index}]`, item.image); // fallback value
            }
            return {
                attribute_id: item.attribute?.value ?? null,
                option_id: item.attributeValue?.value ?? null,
                stock: Number(item.stock),
                price: Number(item.price),
                image: `attribute_images[${index}]`
            }
        });
        formData.append("item_id", param1)
        formData.append("name", data.itemName);
        formData.append("sku", data.sku);
        formData.append("sale_price", data.sales_price);
        formData.append("purchase_price", data.purchase_price);
        formData.append("quantity", data.quantity);
        formData.append("category_id", data.category?.value);
        formData.append("tax_group_id", data.tax?.value);
        formData.append("weight", data.weight);
        formData.append("min_order", data.minOrder);
        formData.append("max_order", data.maxOrder);
        formData.append("featured", data?.isFeatured === 1 ? 1 : 0);
        formData.append("website_show", data?.isWeb === 1 ? 1 : 0);
        formData.append("delivery_charge", data?.isShip === 1 ? 1 : 0);
        formData.append("points", data.point);
        formData.append("seo_title", data?.metaTitle||"");
        formData.append("seo_description", data?.metaDescription||'');
        formData.append("description", data?.description||'');
        if (apiData.length > 0) {
            formData.append('attribute', JSON.stringify(apiData));
        }
        formData.append("image", data.image[0]);
        uploadedImages.forEach((image) => {
            formData.append("additional_images[]", image);
        });
        additionalImages.forEach((img) => {
            formData.append("additional_images[]", img.image); // note: string, not File
        });

        const postResponce = await postClientUrlWithToken(
            authState.apiUrl, editItem, formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        if (postResponce.status === 200) {
            if (postResponce.data.status === true) {
                toast.success(postResponce.data.message);
                navigate(`${process.env.PUBLIC_URL}/Products/item`);
            } else {
                if (Array.isArray(postResponce.data.message)) {
                    postResponce.data.map((e) => { e.message })
                } else {
                    toast.error(postResponce.data.message);
                }
                setLoading(false)
            }
        } else if (postResponce.status >= 400 && postResponce.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (postResponce.status >= 500 && postResponce.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <FormProvider {...methods}>
                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Breadcrumbs mainTitle={EditItem} parent="Product" title={EditItem} />
                    <Card className="tab-company-edit">
                        <Nav className="nav-primary" tabs>
                            <NavItem >
                                <NavLink className={IconWithTab === '1' ? 'active' : ''} onClick={() => setIconWithTab('1')}><span className="fs-6 fw-bold cursor ">{AddItem}</span></NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={IconWithTab === '2' ? 'active' : ''} onClick={() => setIconWithTab('2')}><span className="fs-6 fw-bold cursor">{ProOption}</span></NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={IconWithTab === '3' ? 'active' : ''} onClick={() => setIconWithTab('3')}><span className="fs-6 fw-bold cursor">{SEO}</span></NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={IconWithTab === '4' ? 'active' : ''} onClick={() => setIconWithTab('4')}><span className="fs-6 fw-bold cursor">{AdditionImage}</span></NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={IconWithTab}>
                            <TabPane className="fade show" tabId="1">
                                <CardHeader className="pb-0">
                                    <H3>{AddItem}</H3>
                                </CardHeader>
                                <ItemForm register={register} trigger={trigger} control={control} errors={errors} setNextTab={setIconWithTab}
                                    categoryOption={categoryOption} taxOption={taxOption} apiImage={apiImage} getValues={getValues} />
                            </TabPane>
                            <TabPane tabId="2">
                                <CardHeader className="card-text-color pb-0">
                                    <H3>{ProOption}</H3>
                                </CardHeader>
                                <ProOptionForm
                                    register={register} control={control} errors={errors} setNextTab={setIconWithTab}
                                    setValue={setValue} fields={fields} append={append} remove={remove} itemAttributes={attributeItem}
                                />
                            </TabPane>
                            <TabPane tabId="3">
                                <CardHeader className="card-text-color pb-0">
                                    <H3>{SEO}</H3>
                                </CardHeader>
                                <SEOForm register={register} control={control} setNextTab={setIconWithTab} />
                            </TabPane>
                            <TabPane tabId="4">
                                <CardHeader className="card-text-color pb-0">
                                    <H3>{AdditionImage}</H3>
                                </CardHeader>
                                <DefaultForm images={uploadedImages} setImages={setUploadedImages} additionalImages={additionalImages} setAdditionalImages={setAdditionalImages} />
                            </TabPane>
                        </TabContent>
                    </Card>
                </Form>
            </FormProvider>
        </Fragment>
    );
};

export default ItemEditTab;
